// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2LvHDv","logo":"cUmGOu"};